module.exports = __webpack_public_path__ + "static/media/success_image.ee8b159c.png";